$(document).ready(function () {
  var $carousel = $(".review-carousel");
  $carousel.owlCarousel({
    items: 2.5,
    margin: 16,
    loop: true,
    rewind: true,
    nav: true,
    dots: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    navText: [
      '<span class="owl-prev-btn">&#10094;</span>',
      '<span class="owl-next-btn">&#10095;</span>'
    ],
   responsive: {
      0: { items: 1 },
      768: { items: 2 },
      992: { items: 2.2 },
      1680: { items: 3.1 }
    }

  });
  function updateProgress(e) {
    if (!e.namespace) return;
    var carousel = e.relatedTarget;
    var index = carousel.relative(e.item.index); // :white_check_mark: normalized index
    var count = e.item.count; // total items
    var pct = ((index + 1) / count) * 100;
    $(".review-progress").css("width", pct + "%");
  }
  $carousel.on("initialized.owl.carousel", updateProgress);
  $carousel.on("changed.owl.carousel", updateProgress);
});



//video hover play
document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll(".product-card__hover-video");

  videos.forEach(video => {
    const parent = video.closest(".product-card");

    parent.addEventListener("mouseenter", () => {
      video.play();
    });

    parent.addEventListener("mouseleave", () => {
      video.pause();
      video.currentTime = 0; // reset to start
    });
  });
});



//list-viewfacet js
document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".grid-toggle .grid-btn");
  const grid = document.getElementById("product-grid");

  if (!btn || !grid) return;

  btn.addEventListener("click", () => {
    if (grid.className.includes("medium-up-2")) {
      // switch to 4-column
      grid.className = grid.className.replace(/medium-up-\d/, "medium-up-4");
      btn.querySelector(".icon-grid-2").style.display = "none";
      btn.querySelector(".icon-grid-4").style.display = "block";
    } else {
      // switch back to 2-column
      grid.className = grid.className.replace(/medium-up-\d/, "medium-up-2");
      btn.querySelector(".icon-grid-2").style.display = "block";
      btn.querySelector(".icon-grid-4").style.display = "none";
    }
  });
});


//read less more
document.addEventListener("DOMContentLoaded", function() {
  const btns = document.querySelectorAll(".readmore-btn");

  btns.forEach(btn => {
    btn.addEventListener("click", function() {
      const text = this.previousElementSibling;
      text.classList.toggle("expanded");
      this.textContent = text.classList.contains("expanded") ? "Read Less" : "Read More";
    });
  });
});



function toggleFitTooltip() {
  const tooltip = document.getElementById('fitTooltip');
  tooltip.style.display = tooltip.style.display === 'block' ? 'none' : 'block';
}

function updateFitDescription(fitName) {
  // Hide all fit descriptions
  document.querySelectorAll('.fit-description').forEach(el => el.style.display = 'none');

  // Update selected fit name safely
  const selectedFitEl = document.getElementById('selectedFit');
  const fitTitleEl = document.getElementById('fitTitle');
  const currentFitTitleEl = document.getElementById('currentFitTitle');

  if (selectedFitEl) selectedFitEl.textContent = fitName;
  if (fitTitleEl) fitTitleEl.textContent = fitName;
  if (currentFitTitleEl) currentFitTitleEl.textContent = fitName;

  // Show correct description based on fitName
  if (fitName.toLowerCase().includes("slim")) {
    const slimDesc = document.querySelector('.fit-slim');
    if (slimDesc) slimDesc.style.display = 'block';
  } else if (fitName.toLowerCase().includes("classic")) {
    const classicDesc = document.querySelector('.fit-classic');
    if (classicDesc) classicDesc.style.display = 'block';
  } else if (fitName.toLowerCase().includes("relaxed")) {
    const relaxedDesc = document.querySelector('.fit-relaxed');
    if (relaxedDesc) relaxedDesc.style.display = 'block';
  }
}


document.addEventListener("DOMContentLoaded", function () {
  // Detect fit option select (radio buttons or dropdown)
  const fitInputs = document.querySelectorAll('.product__form input[type="radio"], .product__form select');

  fitInputs.forEach(el => {
    el.addEventListener('change', function () {
      let selectedValue = '';

      if (el.type === 'radio') {
        const checked = document.querySelector('.product__form input[type="radio"]:checked');
        if (checked) selectedValue = checked.value;
      } else if (el.tagName.toLowerCase() === 'select') {
        selectedValue = el.value;
      }

      if (selectedValue) updateFitDescription(selectedValue);
    });
  });

  // Fallback: set initial fit
 const selectedFitEl = document.querySelector('.selected-fit');
const initialFit = selectedFitEl ? selectedFitEl.textContent : 'Slim Fit';
updateFitDescription(initialFit);

});



  //color guide

  function toggleColorNotes() {
    const box = document.getElementById('colorNotesBox');
    box.style.display = box.style.display === 'block' ? 'none' : 'block';
  }

 const colorNotesToggle = document.querySelector('.color-notes-toggle');
if (colorNotesToggle) {
  colorNotesToggle.addEventListener('click', function(e) {
    e.preventDefault();
    toggleColorNotes();
  });
}





const headers = document.querySelectorAll('.accordion-header');

headers.forEach(header => {
  header.addEventListener('click', () => {
    const content = header.nextElementSibling;
    header.classList.toggle('active');
    
    if (header.classList.contains('active')) {
      content.style.maxHeight = content.scrollHeight + "px";
    } else {
      content.style.maxHeight = null;
    }
  });
});





// outlook script
document.addEventListener("DOMContentLoaded", () => {
  const sidebar = document.getElementById("sidebar");
  const overlay = document.getElementById("overlay");
  const openBtn = document.getElementById("openSidebar");
  const closeBtn = document.getElementById("closeSidebar");

  openBtn?.addEventListener("click", () => {
    sidebar.classList.add("active");
    overlay.classList.add("active");

    // Add outlook class to body
    document.body.classList.add("outlook");
  });

  closeBtn?.addEventListener("click", () => {
    sidebar.classList.remove("active");
    overlay.classList.remove("active");

    // Add outlook class to body
    document.body.classList.remove("outlook");
  });

  overlay?.addEventListener("click", () => {
    sidebar.classList.remove("active");
    overlay.classList.remove("active");
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const sidebar = document.getElementById("sidebar");
  const overlay = document.getElementById("overlay");
  const openBtn = document.getElementById("openSidebar");
  const closeBtn = document.getElementById("closeSidebar");

  // Sidebar open/close
  openBtn?.addEventListener("click", () => {
    sidebar.style.display = "block";
    overlay.style.display = "block";
  });

  closeBtn?.addEventListener("click", () => {
    sidebar.style.display = "none";
    overlay.style.display = "none";
  });

  overlay?.addEventListener("click", () => {
    sidebar.style.display = "none";
    overlay.style.display = "none";
  });

  // Loop through each item in sidebar
  document.querySelectorAll(".item").forEach(item => {
    const productHandle = item.dataset.productHandle;
    if (!productHandle) return;

    const imageEl = item.querySelector(".product-image");
    const addToCartBtn = item.querySelector(".outlook-add-to-cart");
    const priceEl = item.querySelector(".price-section .price");
    const colorTextEl = item.querySelector(".swach-product-info .color");
    const sizeTextEl = item.querySelector(".swach-product-info .size");
    const colorContainer = item.querySelector(".colors");
    const sizeContainer = item.querySelector(".sizes");

    if (!imageEl || !addToCartBtn || !priceEl) return;

    let selectedColor = null;
    let selectedSize = null;

   const colorMap = {
        "Black": "#000000",
        "White": "#FFFFFF",
        "White htr": "#FFFFFF",
        "Off-White": "#F8F8F8",
        "Red": "#EB2C2C",
        "Teal": "#039992",
        "Soft Pink": "#FFDBF5",
        "Lilac": "#BDA0CF",
        "Mint": "#B7E0D5",
        "Skyblue": "#B4E2EC",
        "Sky Blue": "#B4E2EC",
        "Baby blue": "#9FC5E8",
        "Kiwi Green": "#8EE53F",
        "Kiwigreen": "#BFDCAA",
        "Kiwi": "#8EE53F",
        "Olive Green": "#4F6F3E",
        "Olive Green / White": "#4F6F3E",
        "Bottle Green": "#1C5C39",
        "Moss Green": "#CAFFB1",
        "Sage green": "#68C4AD",
        "Navy blue": "#000080",
        "Navy Blue": "#314A73",
        "Dark Navy Blue": "#073763",
        "Dark Navy Blue / White": "#073763",
        "Midnight Blue": "#191970",
        "Marlin Blue": "#6A88B8",
        "Ocean blue": "#C9DAF8",
        "Ocean Blue": "#B4E2EC",
        "Petrol Blue": "#185B80",
        "Petrol Blue / yellow": "#185B80",
        "Royal Blue": "#3E87C7",
        "Royal Blue / White": "#3D85C6",
        "Slate Blue": "#5A7BCD",
        "PURPLE": "#314A73",
        "Asphalt": "#999999",
        "Grey Htr": "#D9D9D9",
        "Grey / Navy Htr": "#808080",
        "Grey / Black": "#808080",
        "Stone Grey": "#928E85",
        "Yellow": "#FDFC00",
        "Pale yellow": "#FFF3B8",
        "Tangerine": "#FF9900",
        "Orange": "#FF8A00",
        "Wine Red": "#722F37",
        "Maroon": "#8C3E41",
        "Cardinal Htr": "#DD7E6B",
        "Brown": "#9A5630",
        "Cafe": "#B38470",
        "Umber": "#B38470",
        "Dessert": "#EDC9AF",
        "Sunset": "#FFB798",
        "Smoky Blue": "#005BD3",
        "Cyan": "#00FFFF",
        "Pink": "#E87999"
      };



    // Fetch product JSON
    fetch(`/products/${productHandle}.js`)
      .then(res => {
        if (!res.ok) throw new Error("Product JSON not found");
        return res.json();
      })
      .then(product => {
        const variants = product.variants.filter(v => v.available);

        // Get unique colors and sizes
        const allColors = [...new Set(variants.map(v => v.option1).filter(Boolean))];
        const allSizes = [...new Set(variants.map(v => v.option2).filter(Boolean))];

        // Render colors
        if (colorContainer) {
          colorContainer.innerHTML = "";
          allColors.forEach(color => {
            const swatch = document.createElement("span");
            swatch.className = "color-swatch";
            swatch.dataset.color = color;
            swatch.title = color;
            swatch.style.display = "inline-block";
            swatch.style.width = "24px";
            swatch.style.height = "24px";
            swatch.style.borderRadius = "50%";
            swatch.style.marginRight = "8px";
            swatch.style.border = "1px solid #ccc";
            swatch.style.cursor = "pointer";
            swatch.style.background = colorMap[color] || color.toLowerCase();
            colorContainer.appendChild(swatch);
          });
        }

        // Render sizes
        if (sizeContainer) {
          sizeContainer.innerHTML = "";
          allSizes.forEach(size => {
            const btn = document.createElement("button");
            btn.className = "size-btn";
            btn.dataset.size = size;
            btn.textContent = size;
            btn.style.marginRight = "6px";
            btn.style.padding = "4px 8px";
            btn.style.cursor = "pointer";
            sizeContainer.appendChild(btn);
          });
        }

        // Event listeners
        const colorSwatches = item.querySelectorAll(".color-swatch");
        const sizeButtons = item.querySelectorAll(".size-btn");

        colorSwatches.forEach(swatch => {
          swatch.addEventListener("click", () => {
            if (swatch.classList.contains("disabled")) return;
            colorSwatches.forEach(s => s.classList.remove("active"));
            swatch.classList.add("active");
            selectedColor = swatch.dataset.color;
            updateAvailableSizes();
            updateVariantDetails();
          });
        });

        sizeButtons.forEach(btn => {
          btn.addEventListener("click", () => {
            if (btn.disabled) return;
            sizeButtons.forEach(b => b.classList.remove("active"));
            btn.classList.add("active");
            selectedSize = btn.dataset.size;
            updateAvailableColors();
            updateVariantDetails();
          });
        });

        function updateAvailableSizes() {
          sizeButtons.forEach(btn => {
            const size = btn.dataset.size;
            const exists = variants.some(v => v.option1 === selectedColor && v.option2 === size);
            btn.disabled = !exists;
            btn.style.opacity = exists ? "1" : "0.4";
            btn.style.cursor = exists ? "pointer" : "not-allowed";
            if (btn.classList.contains("active") && !exists) {
              btn.classList.remove("active");
              selectedSize = null;
            }
          });
        }

        function updateAvailableColors() {
          colorSwatches.forEach(swatch => {
            const color = swatch.dataset.color;
            const exists = variants.some(v => v.option1 === color && v.option2 === selectedSize);
            if (exists) {
              swatch.classList.remove("disabled");
              swatch.style.opacity = "1";
              swatch.style.pointerEvents = "auto";
              swatch.style.cursor = "pointer";
            } else {
              swatch.classList.add("disabled");
              swatch.style.opacity = "0.4";
              swatch.style.pointerEvents = "none";
              swatch.style.cursor = "not-allowed";
              if (swatch.classList.contains("active")) {
                swatch.classList.remove("active");
                selectedColor = null;
              }
            }
          });
        }

        function updateVariantDetails() {
          let matched = null;

          if (selectedColor && selectedSize) {
            matched = variants.find(v => v.option1 === selectedColor && v.option2 === selectedSize);
          } else if (selectedColor) {
            matched = variants.find(v => v.option1 === selectedColor);
          } else if (selectedSize) {
            matched = variants.find(v => v.option2 === selectedSize);
          }

          if (!matched && variants.length) matched = variants[0];

          if (matched) {
            addToCartBtn.dataset.variantId = matched.id;

            // Update image
            if (matched.featured_image && imageEl) {
              imageEl.src = matched.featured_image.src;
            }

            // Update price
            if (matched.compare_at_price > matched.price && priceEl) {
              priceEl.innerHTML = `<span style="text-decoration: line-through; color:gray; padding-left:8px;">${formatMoney(matched.compare_at_price)}</span> <span style="font-weight:600; color:#991c1e;">${formatMoney(matched.price)}</span>`;
            } else if (priceEl) {
              priceEl.textContent = formatMoney(matched.price);
            }

            // Update color/size text
            if (colorTextEl) colorTextEl.textContent = matched.option1 || "Not selected";
            if (sizeTextEl) sizeTextEl.textContent = matched.option2 || "Not selected";

            addToCartBtn.disabled = false;
            addToCartBtn.textContent = "ADD TO CART";
          } else {
            addToCartBtn.dataset.variantId = "";
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = "Unavailable";
            if (colorTextEl) colorTextEl.textContent = "Not selected";
            if (sizeTextEl) sizeTextEl.textContent = "Not selected";
          }
        }

        function formatMoney(cents) {
          if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
            return Shopify.formatMoney(cents);
          }
          return "$" + (cents / 100).toFixed(2);
        }

        // Initialize first available options
        if (allColors.length) {
          selectedColor = allColors[0];
          colorSwatches.forEach(s => {
            if (s.dataset.color === selectedColor) s.classList.add("active");
          });
        }
        if (allSizes.length) {
          selectedSize = allSizes[0];
          sizeButtons.forEach(b => {
            if (b.dataset.size === selectedSize) b.classList.add("active");
          });
        }

        updateAvailableSizes();
        updateAvailableColors();
        updateVariantDetails();

        // Add to cart AJAX
        addToCartBtn.addEventListener("click", () => {
          const variantId = addToCartBtn.dataset.variantId;
          if (!variantId) return alert("Please select a valid color and size.");

          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          })
            .then(res => {
              if (!res.ok) throw new Error("Failed to add to cart");
              return res.json();
            })
            .then(() => {
              addToCartBtn.textContent = "ADDED!";
              addToCartBtn.disabled = true;
              setTimeout(() => {
                addToCartBtn.textContent = "ADD TO CART";
                addToCartBtn.disabled = false;
              }, 2000);
            })
            .catch(() => alert("Error adding to cart"));
        });

      })
      .catch(err => {
        console.error(`Failed to load product JSON for handle: ${productHandle}`, err);
      });
  });
});



//kaching cart add class for design progreesbar...

function updateProgressFillClass() {
    const progressFill = document.querySelector('.kaching-cart__tiered-promotions-bar-progress-fill');
    if (!progressFill) return;

    const parentWidth = progressFill.parentElement.offsetWidth;
    const fillWidth = progressFill.offsetWidth;

    if (Math.abs(fillWidth - parentWidth) < 1) {
        progressFill.classList.add('full-width');
    } else {
        progressFill.classList.remove('full-width');
    }
}

// Run after DOM is fully loaded
window.addEventListener('load', updateProgressFillClass);
// Also run on resize (optional, in case width changes dynamically)
window.addEventListener('resize', updateProgressFillClass);



document.addEventListener("DOMContentLoaded", function () {

  const sticky = document.querySelector(".sticky-atc");
  const productForm = document.querySelector('form[action*="/cart/add"]');

  if (!sticky || !productForm) return;

  window.addEventListener("scroll", function () {
    const rect = productForm.getBoundingClientRect();

    if (rect.bottom < 0) {
      sticky.classList.add("show");
    } else {
      sticky.classList.remove("show");
    }
  });

});